import React from "react";

import { Typography } from "antd";
import styled from "styled-components";

import { AutomationCommandProps } from "../types/automation";
import { LoadSavedFilterPayload } from "../types/payloads";

const { Text } = Typography;
const LoadSavedFilterCommand: React.FC<AutomationCommandProps> = (props) => {
  const payload = props.command.payload as LoadSavedFilterPayload;
  return (
    <RootContainer>
      {payload?.filterName ? (
        <div>
          Load <Text strong>{payload?.filterName}</Text>
          {"  "} Filter
        </div>
      ) : (
        <div>No Filter Selected</div>
      )}
    </RootContainer>
  );
};

export default LoadSavedFilterCommand;

const RootContainer = styled.div``;
